module.exports = __webpack_public_path__ + "img/Therapax-logo-shadow.7dcb6978.png";